<template>
  <div class="container" ref="container">
    <survey :survey="survey"></survey>
  </div>
</template>

<script>
import * as SurveyVue from "survey-vue";
var Survey = SurveyVue.Survey;

export default {
  components: {
    Survey,
  },
  data() {
    var model = new SurveyVue.Model(this.$store.state.config);
    model.css = {
      navigationButton: "pds-c-button quiz-button",
    };
    model.onComplete.add(this.onCompleted);
    model.onAfterRenderQuestion.add(this.onAfterRenderQuestion);
    model.locale = "nl";    
    model.setLocalizableStringText("completeText", "Klaar!");
    return {
      survey: model 
    };
  },
  methods: {
    onCompleted(sender) {
      this.$store.commit("setAnswers", sender.data);
      this.$store.commit("setQuizQuestions", sender.getQuizQuestions());
      this.$router.push({ path: "result" });
    },
    onAfterRenderQuestion(sender, question, questionHTML) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  },
};
</script>

<style>

</style>
